/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Apply_EditInputs */

const en_landing_studio_apply_edit = /** @type {(inputs: Landing_Studio_Apply_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply edit`)
};

const zh_landing_studio_apply_edit = /** @type {(inputs: Landing_Studio_Apply_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用修改`)
};

/**
* | output |
* | --- |
* | "Apply edit" |
*
* @param {Landing_Studio_Apply_EditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_apply_edit = /** @type {((inputs?: Landing_Studio_Apply_EditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Apply_EditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_apply_edit(inputs)
	return zh_landing_studio_apply_edit(inputs)
});
export { landing_studio_apply_edit as "landing.studio.apply_edit" }